/**
 * Telugu (India) locale for phone-numbers page.
 * Export is the "phoneNumbers" subtree for host i18n merge.
 */
import type { PhoneNumbersLocale } from './en'

export const phoneNumbersTeIn = {
  list: {
    title: `ఫోన్ నంబర్లు`,
    serverGroup: `సర్వర్ గ్రూప్:`,
    searchPlaceholder: `వెతకండి...`,
    loading: `ఫోన్ నంబర్లు లోడ్ అవుతున్నాయి...`,
    error: `ఫోన్ నంబర్లను లోడ్ చేయడంలో విఫలమైంది`,
    empty: `ఈ PBX కు ఫోన్ నంబర్లు కనుగొనబడలేదు`,
    noResults: `మీ శోధనకు సరిపోలిన ఫోన్ నంబర్లు లేవు`,
    columnName: `పేరు`,
    columnNumber: `నంబర్`,
    columnExtension: `ఎక్స్‌టెన్షన్`,
    columnCallerId: `కాలర్ ID`,
    columnType: `రకం`,
    columnTollFree: `టోల్ ఫ్రీ`,
    columnSms: `SMS`,
    columnE911: `e911`,
    columnVoiceProvider: `వాయిస్ ప్రొవైడర్`,
    columnSmsProvider: `SMS ప్రొవైడర్`,
    columnProviders: `ప్రొవైడర్లు`,
    columnStatus: `స్థితి`,
    columnUpdated: `నవీకరించబడింది`,
    yes: `అవును`,
    no: `కాదు`,
    smsActive: `సక్రియం`,
    e911Verified: `ధృవీకరించబడింది`,
    createButton: `+ ఫోన్ నంబర్ సృష్టించండి`,
    createDisabledTooltip: `ఫోన్ నంబర్ సృష్టి ఫోన్ బృందం ద్వారా నిర్వహించబడుతుంది`,
    filterButton: `ఫిల్టర్‌లు`,
    copyNumber: `నంబర్‌ను కాపీ చేయండి`,
    toast: {
      createSuccess: `ఫోన్ నంబర్ సృష్టించబడింది`,
      createFailed: `ఫోన్ నంబర్ సృష్టించడంలో విఫలమైంది`,
      copied: `నంబర్ క్లిప్‌బోర్డ్‌కు కాపీ చేయబడింది`,
      copyFailed: `నంబర్‌ను కాపీ చేయడంలో విఫలమైంది`,
    },
  },
  filters: {
    status: `స్థితి`,
    allStatuses: `అన్నీ`,
    type: `రకం`,
    allTypes: `అన్నీ`,
    voiceProvider: `వాయిస్ ప్రొవైడర్`,
    smsProvider: `SMS ప్రొవైడర్`,
    allProviders: `అన్నీ`,
    tollFree: `టోల్ ఫ్రీ`,
    any: `ఏదైనా`,
    showDeleted: `తొలగించినవి చూపించు`,
    clearAll: `ఫిల్టర్‌లు తీసివేయి`,
  },
  types: {
    callerId: `కాలర్ ID`,
    smsOnly: `SMS మాత్రమే`,
    standard: `స్టాండర్డ్`,
    temporary: `తాత్కాలిక`,
  },
  bulk: {
    title: `బల్క్ స్థితి నవీకరణ`,
    description: `ఎంచుకున్న ఫోన్ నంబర్(ల) స్థితిని నవీకరించండి.`,
    selected: `{{count}} ఎంచుకోబడ్డాయి`,
    apply: `వర్తింపజేయి`,
    updateStatus: `స్థితి నవీకరించు`,
    clearSelection: `తీసివేయి`,
    maxExceeded: `ఒకసారికి గరిష్టంగా 25`,
    selectAll: `అన్ని ఫోన్ నంబర్‌లను ఎంచుకోండి`,
    selectRow: `{{number}} ఎంచుకోండి`,
    toast: {
      success: `స్థితి విజయవంతంగా నవీకరించబడింది`,
      failed: `బల్క్ స్థితి నవీకరణ విఫలమైంది`,
    },
    results: {
      titleSuccess: `బల్క్ నవీకరణ పూర్తయింది`,
      titleAllFailed: `బల్క్ నవీకరణ విఫలమైంది`,
      titlePartial: `బల్క్ నవీకరణ పాక్షికంగా పూర్తయింది`,
      summarySuccess: `{{count}} ఫోన్ నంబర్(లు) విజయవంతంగా నవీకరించబడ్డాయి.`,
      summaryAllFailed: `మొత్తం {{count}} ఫోన్ నంబర్(లు) నవీకరించడంలో విఫలమయ్యాయి.`,
      summaryPartial: `{{totalCount}}లో {{successCount}} నవీకరించబడ్డాయి. {{failedCount}} విఫలమయ్యాయి:`,
      colNumber: `నంబరు`,
      colStatus: `ప్రస్తుత స్థితి`,
      colError: `లోపం`,
      close: `మూసివేయి`,
    },
  },
  detail: {
    loading: `ఫోన్ నంబర్ లోడ్ అవుతోంది...`,
    error: `ఫోన్ నంబర్‌ను లోడ్ చేయడంలో విఫలమైంది`,
    backToList: `జాబితాకు తిరిగి`,
    editButton: `ఫోన్ నంబర్ సవరించు`,
    deleteTitle: `ఫోన్ నంబర్ తొలగించు`,
    deleteButton: `తొలగించు`,
    deleteConfirmation: `ఇది ఫోన్ నంబర్‌ను సాఫ్ట్-డిలీట్ చేస్తుంది. అవసరమైతే తర్వాత పునరుద్ధరించవచ్చు. మీరు ఖచ్చితంగా కొనసాగించాలనుకుంటున్నారా?`,
    restoreButton: `పునరుద్ధరించు`,
    noopSaveButton: `మళ్ళీ సేవ్ చేయి`,
    deleted: `తొలగించబడింది`,
    sectionGeneral: `సాధారణ సమాచారం`,
    sectionProviders: `ప్రొవైడర్లు`,
    sectionRouting: `రౌటింగ్`,
    sectionSms: `SMS`,
    sectionE911: `E911 సమాచారం`,
    sectionTimestamps: `టైమ్‌స్టాంప్‌లు`,
    sectionSmsDiagnostics: `Telnyx SMS డయాగ్నస్టిక్స్`,
    diagnosticWarning: `హెచ్చరిక`,
    fieldName: `పేరు`,
    fieldNumber: `నంబర్`,
    fieldPbx: `PBX`,
    fieldType: `రకం`,
    fieldCallerId: `కాలర్ ID`,
    fieldExtension: `ఎక్స్‌టెన్షన్`,
    fieldTollFree: `టోల్ ఫ్రీ`,
    fieldCountryCode: `దేశ కోడ్`,
    fieldLocalPresence: `స్థానిక ఉనికి`,
    fieldCampaignId: `ప్రచార ID`,
    fieldVoiceProvider: `వాయిస్ ప్రొవైడర్`,
    fieldSmsProvider: `SMS ప్రొవైడర్`,
    fieldSmsEnabled: `SMS ప్రారంభించబడింది`,
    fieldSmsStatus: `SMS స్థితి`,
    fieldSmsRelay: `SMS రిలే`,
    fieldSmsRelayIntegration: `SMS రిలే ఇంటిగ్రేషన్`,
    fieldSmsGroup: `SMS గ్రూప్`,
    fieldE911Status: `E911 స్థితి`,
    fieldE911Address: `చిరునామా`,
    fieldE911Address2: `చిరునామా 2`,
    fieldE911City: `నగరం`,
    fieldE911State: `రాష్ట్రం`,
    fieldSendFaxesFrom: `ఫ్యాక్స్ పంపే నంబర్`,
    usePbxDefault: `PBX డిఫాల్ట్ ఉపయోగించు`,
    fieldPbxServerGroup: `PBX సర్వర్ గ్రూప్`,
    fieldSourceTracking: `సోర్స్ ట్రాకింగ్`,
    fieldStatus: `స్థితి`,
    fieldE911PostalCode: `పిన్ కోడ్`,
    fieldCreatedAt: `సృష్టించబడింది`,
    fieldUpdatedAt: `నవీకరించబడింది`,
    viewInProvider: `{{provider}} లో వీక్షించండి`,
    sectionMetrics: `మెట్రిక్స్`,
    fieldCallStats: `కాల్ స్టాట్స్`,
    callStatsLink: `కాల్ స్టాట్స్`,
    on: `ఆన్`,
    off: `ఆఫ్`,
    registered: `నమోదైంది`,
    inactive: `నిష్క్రియం`,
    notRegistered: `నమోదు కాలేదు`,
    toast: {
      updateSuccess: `ఫోన్ నంబర్ నవీకరించబడింది`,
      updateFailed: `ఫోన్ నంబర్ నవీకరించడంలో విఫలమైంది`,
      deleteSuccess: `ఫోన్ నంబర్ తొలగించబడింది`,
      deleteFailed: `ఫోన్ నంబర్ తొలగించడంలో విఫలమైంది`,
      restoreSuccess: `ఫోన్ నంబర్ పునరుద్ధరించబడింది`,
      restoreFailed: `ఫోన్ నంబర్ పునరుద్ధరించడంలో విఫలమైంది`,
      noopSaveSuccess: `సైడ్ ఎఫెక్ట్‌లు మళ్లీ ట్రిగ్గర్ చేయబడ్డాయి`,
      noopSaveFailed: `మళ్లీ సేవ్ చేయడంలో విఫలమైంది`,
    },
  },
  edit: {
    title: `ఫోన్ నంబర్ సవరించు`,
    numberLabel: `నంబర్`,
    nameLabel: `పేరు`,
    namePlaceholder: `ఫోన్ నంబర్ పేరు`,
    typeLabel: `రకం`,
    statusLabel: `స్థితి`,
    selectStatus: `— స్థితి ఎంచుకోండి —`,
    voiceProviderLabel: `వాయిస్ ప్రొవైడర్`,
    smsProviderLabel: `SMS ప్రొవైడర్`,
    selectProvider: `— ఎంచుకోండి —`,
    unassigned: `కేటాయించబడలేదు`,
    callerIdLabel: `కాలర్ ID`,
    sendFaxesFromLabel: `ఫ్యాక్స్ పంపే నంబర్`,
    usePbxDefault: `PBX డిఫాల్ట్ ఉపయోగించు`,
    extensionLabel: `ఎక్స్‌టెన్షన్`,
    extensionPlaceholder: `ఎక్స్‌టెన్షన్ UUID`,
    extensionHelp: `ఫోన్ నంబర్ కోసం ఐచ్ఛిక ఎక్స్‌టెన్షన్.`,
    noExtension: `ఏదీ లేదు`,
    sourceTrackingLabel: `సోర్స్ ట్రాకింగ్`,
    sourceTrackingHelp: `ఇన్‌బౌండ్ కాల్స్ కోసం కాలర్ ID ముందు 6 అక్షరాల వరకు జతచేయండి. ఇది సాధారణంగా ప్రకటన ప్రచారాలను ట్రాక్ చేయడానికి ఉపయోగించబడుతుంది.`,
    localPresenceLabel: `స్థానిక ఉనికి`,
    localPresenceHelp: `స్థానిక ఉనికి గ్రూప్‌లు నంబర్ల పూల్‌ను సృష్టిస్తాయి, దాని నుండి స్థానిక ఉనికి ప్రారంభించబడిన లైన్ ఎక్స్‌టెన్షన్ కాల్ చేయగలదు, తద్వారా స్వీకర్తకు స్థానికంగా కనిపిస్తుంది.`,
    e911Section: `అత్యవసర 911 (E911) సెట్టింగ్‌లు`,
    e911AddressLabel: `చిరునామా`,
    e911Address2Label: `అపార్ట్‌మెంట్/సూట్`,
    e911CityLabel: `నగరం`,
    e911StateLabel: `రాష్ట్రం/ప్రావిన్స్`,
    e911PostalCodeLabel: `పిన్ కోడ్`,
    e911Disclaimer: `E911 అనేది ఉత్తర అమెరికాలో కాలర్ స్థానాన్ని 911 డిస్పాచర్లకు స్వయంచాలకంగా అందించడానికి ఉపయోగించే వ్యవస్థ. దయచేసి ఈ సమాచారం ఖచ్చితంగా ఉందని నిర్ధారించుకోండి — ఎవరైనా ప్రాణం దీనిపై ఆధారపడి ఉండవచ్చు.`,
    smsSection: `SMS సెట్టింగ్‌లు`,
    smsEnabledLabel: `SMS ప్రారంభించబడింది`,
    smsEnabledWarning: `హెచ్చరిక: SMS ప్రారంభించడం ఈ నంబర్‌పై eSPID పోర్ట్-ఇన్ అభ్యర్థనను ప్రేరేపిస్తుంది, ఇది గ్రాహకుడికి SMS డౌన్‌టైమ్‌ను కలిగించవచ్చు. కొనసాగడానికి ముందు ఇది కావలసిన చర్యనని నిర్ధారించుకోండి.`,
    smsRelayLabel: `SMS రిలే`,
    smsRelayIntegrationLabel: `SMS రిలే ఇంటిగ్రేషన్`,
    smsRelayIntegrationDisabledHelp: `ఇంటిగ్రేషన్‌ను ఎంచుకోవడానికి SMS రిలేను ప్రారంభించండి.`,
    noIntegration: `ఏదీ లేదు`,
    integrationSearchPlaceholder: `ఇంటిగ్రేషన్లను శోధించండి...`,
    integrationSearchAriaLabel: `పేరు ద్వారా SMS రిలే ఇంటిగ్రేషన్లను శోధించండి`,
    noIntegrationMatches: `ఆ శోధనకు సరిపోలే ఏ ఇంటిగ్రేషన్ లేదు.`,
    campaignIdLabel: `ప్రచారం ID`,
    campaignIdHelp: `SMS పంపడానికి అవసరం. ఈ విలువను సెట్ చేయడానికి ముందు, సంబంధిత ప్రొవైడర్‌లో ప్రచారం ID ఈ నంబర్‌కు లింక్ చేయబడిందని నిర్ధారించుకోండి. అలా చేయకపోతే సేవ అంతరాయం, డెలివరీ వైఫల్యాలు మరియు/లేదా జరిమానాలు రావచ్చు.`,
    titleWithNumber: `ఫోన్ నంబర్‌ను సవరించండి — {{number}}`,
    advancedSection: `అధునాతన`,
    e911NotConfigured: `కాన్ఫిగర్ చేయబడలేదు`,
    extensionSearchPlaceholder: `ఎక్స్‌టెన్షన్‌లను శోధించండి...`,
    extensionSearchAriaLabel: `పేరు లేదా నంబర్ ద్వారా ఎక్స్‌టెన్షన్‌లను శోధించండి`,
    noExtensionMatches: `ఆ శోధనతో సరిపోలే ఎక్స్‌టెన్షన్ లేదు.`,
    cancel: `రద్దు`,
    save: `సేవ్`,
  },
  create: {
    title: `ఫోన్ నంబర్ సృష్టించు`,
    numberLabel: `ఫోన్ నంబర్`,
    numberPlaceholder: `+1234567890`,
    numberHelp: `దేశ కోడ్ తప్పనిసరిగా చేర్చాలి (ఉదా. US కోసం +18015551234, UK కోసం +442079460958).`,
    numberHelpWithPrefix: `దేశ కోడ్ లేకుండా నంబర్ నమోదు చేయండి.`,
    selectType: `— రకం ఎంచుకోండి —`,
    saveButton: `సృష్టించు`,
    createMore: `మరిన్ని సృష్టించు`,
    searchStateProvince: `శోధించండి...`,
    noStateProvinceMatches: `ఫలితాలు లేవు`,
  },
  validation: {
    numberRequired: `ఫోన్ నంబర్ అవసరం`,
    numberInvalid: `చెల్లుబాటు అయ్యే ఫోన్ నంబర్‌ను నమోదు చేయండి (ఉదా. +1 (801) 555-1234)`,
    numberInvalidNational: `చెల్లుబాటు అయ్యే ఫోన్ నంబర్ నమోదు చేయండి (ఉదా. (801) 555-1234)`,
    numberMissingCountryCode: `ఫోన్ నంబర్‌లో దేశ కోడ్ ఉండాలి (ఉదా. US కోసం +1, UK కోసం +44)`,
    nameRequired: `పేరు అవసరం`,
    typeRequired: `రకం అవసరం`,
    statusRequired: `స్థితి అవసరం`,
    voiceProviderRequired: `వాయిస్ ప్రొవైడర్ అవసరం`,
    callerIdTooLong: `గరిష్టంగా 15 అక్షరాలు`,
    callerIdInvalidChars: `అక్షరాలు, సంఖ్యలు మరియు ఖాళీలు మాత్రమే అనుమతించబడతాయి`,
    callerIdAllDigits: `అన్ని అంకెలు కాకూడదు`,
    campaignIdFormat: `ఖచ్చితంగా 7 ఆల్ఫాన్యూమరిక్ అక్షరాలు ఉండాలి`,
    sourceTrackingFormat: `1-6 ఆల్ఫాన్యూమరిక్ అక్షరాలు మాత్రమే`,
    e911Incomplete: `ఏదైనా E911 ఫీల్డ్ నింపబడినప్పుడు చిరునామా, నగరం, రాష్ట్రం మరియు పిన్ కోడ్ అన్నీ అవసరం`,
  },
  pagination: {
    resultsPerPage: `పేజీకి ఫలితాలు:`,
    previousPage: `మునుపటి పేజీ`,
    nextPage: `తదుపరి పేజీ`,
    jumpToPage: `పేజీ {{page}} కు వెళ్ళండి`,
    all: `అన్నీ`,
    recordRange: `{{start}}-{{end}} / {{total}} మొత్తం`,
    recordRangeEmpty: `0 / 0`,
  },
} satisfies PhoneNumbersLocale
